import "../footer-modal.scss";
import "../../../../scss/common.scss";


const PrivacyPolicy = () => {
  return (
    <>
      <div className="modalContent">
        <p className="label-color fs-18">
          Your privacy is important to us at DRIVERTOK. We will only use your
          personal information to administer your account, provide the products
          and services you have requested from us, and to keep you informed
          about our products and services. The protection, confidentiality and
          integrity of your personal data are our prime concerns. This privacy
          notice explains what personal information we collect from you when you
          interact with our products and services, and how we use this
          information.We will inform you of any future changes to our processing
          purposes or our Privacy Policy.
        </p>
        <h2 className="fs-22 label-color">What personal data do we collect?</h2>
        <ul>
          <li>
            <p className="label-color fs-18">
              We collect personal information about you while running our
              business and providing our services to you.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              We may collect personal information about you from a variety of
              sources for example:
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              Directly from you, our customers, and prospective customers, when
              you complete surveys or are using or enquiring about our products
              or services.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              From our business partners where we provide you with our products
              or services on their behalf.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              From service providers where they provide you with services or
              products on our behalf or where we use them to help us provide our
              products or services to you.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              From cookies (for information regarding cookies, please see the
              cookie and profiling section below) and from government agencies
              such as the DVLA where lawfully allowed or required.
            </p>
          </li>
        </ul>

        <p className="label-color fs-18">The personal information we collect ourselves may include your:</p>
        <ul>
          <li>
            <p className="label-color fs-18">Name</p>
          </li>
          <li>
            <p className="label-color fs-18">Contact details (telephone number, email address, address)</p>
          </li>
          <li>
            <p className="label-color fs-18">Banking and financial details to facilitate payment.</p>
          </li>
          <li>
            <p className="label-color fs-18">
              CCTV images (which may capture ethnicity and health conditions)
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              Other images, such as, visual call images or documents provided
              for photographic identification purposes.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              Our website collects information about your computer, including
              (where available) your IP address, operating system, and browser
              type, for system administration, to filter traffic, to look up
              user domains and to report on statistics.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              Details of your visits to our website, the pages you view and
              resources you access or download, including but not limited to,
              traffic data and location data.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">
              Vehicle details (including vehicle registration marks or numbers
              (VRM))
            </p>
          </li>
          <li>
            <p className="label-color fs-18">OCompany name (if applicable)</p>
          </li>
          <li>
            <p className="label-color fs-18">
              Our website collects information about your computer, including
              (where available) your IP address, operating system, and browser
              type, for system administration, to filter traffic, to look up
              user domains and to report on statistics.
            </p>
          </li>
          <li>
            <p className="label-color fs-18">Business registration number</p>
          </li>
          <li>
            <p className="label-color fs-18">The date and time you used the service.</p>
          </li>
          <li>
            <p className="label-color fs-18">Any information within correspondence you send to us.</p>
          </li>
        </ul>
        <br />
        <br />
        <br />
        <p className="label-color fs-18">How we use your information</p>
        <p className="label-color fs-18">
          We use personal information for the purpose for which it has been
          provided or obtained.
        </p>
        <p className="label-color fs-18">
          We use your personal information on one or more of the following legal
          bases:
        </p>
        <ul>
          <li className="label-color fs-18">With your express consent</li>
          <li className="label-color fs-18">Legal obligation</li>
          <li className="label-color fs-18">For legitimate business purposes.</li>
          <li className="label-color fs-18">And/or to perform a contract or an agreement with you.</li>
        </ul>
        <br />
        <br />
        <br />
        <p className="label-color fs-18">This enables us to use your personal information:</p>
        <ul>
          <li className="label-color fs-18">
            To provide the service or product you have requested or purchased.
          </li>
          <li className="label-color fs-18">
            To manage our relationships with you, and with our business partners
          </li>
          <li className="label-color fs-18">To contact you if any issues arise</li>
          <li className="label-color fs-18">To market our services and products to you</li>
          <li className="label-color fs-18">
            To understand the way people, use our services and products so we
            can improve them.
          </li>
          <li className="label-color fs-18">For employee recruitment</li>
          <li>
            To assess and analyse our market, customers, products, and services.
          </li>
          <li className="label-color fs-18">For the Issuing PCN and Facilitating appeal process</li>
          <li className="label-color fs-18">For the prevention or detection of crime; and</li>
          <li className="label-color fs-18">To comply with our legal obligations</li>
        </ul>
        <br />
        <br />
        <p className="label-color fs-18">
          We also use your information to analyse and profile your purchasing
          preferences (e.g. market, customer and product analysis) to enable us
          to provide you with a personalised customer service experience, make
          decisions about you using computerised or automated technology. For
          example, automatically selecting products and/or services which we
          think will interest you from the information we have. <br /> We may
          supplement the information that you provide to us with information
          that we receive from third parties. We will carry out searches with
          credit reference agencies and any information provided to us may be
          passed to these credit reference agencies for the purposes of
          confirming credit worthiness. It is our policy to use information that
          cannot directly identify an individual wherever possible. Telephone
          calls <br />
          We may record telephone and intercom calls to verify content which may
          then be used together with other customer records we hold for
          regulatory compliance, quality control and staff training, preventing,
          or detecting criminal activity and for complaint resolution.
        </p>
        <br />
        <br />
        <h2 className="fs-22 label-color">Where is your personal data processed?</h2>
        <p className="label-color fs-18">
          Your personal data is mainly processed by our staff in the United
          Kingdom. We may also share data with our affiliates in the context of
          operating our business, providing our services and other processing
          purposes as outlined in this Privacy Notice. To the extent any other
          personal data will be transferred to a country outside the European
          Union or an international organisation, we will make sure that this
          only happens to such countries and international organisations that
          ensure an adequate level of protection, have put appropriate
          safeguards in place to protect your data and your rights in accordance
          with the EU privacy law (GDPR), or as is otherwise allowed under the
          GDPR.
          <br /> If you wish to receive more information of the safeguards we
          have implemented, please contact our Customer Support team.
        </p>
        <br />
        <br />
        <h2 className="fs-22 label-color">How long do we keep your personal data?</h2>
        <p className="label-color fs-18">
          We will retain your personal information only for as long as is
          necessary for the purposes for which the information was collected, or
          as long as is required pursuant to law.
          <br /> If you do not use your account for more than 18 months, we will
          mark it in our database as "inactive". We will then no longer actively
          use your account information, e.g. to inform you on our products and
          services, but will archive the account to be able to easily
          re‐activate it should you wish to use our services again in the
          future.
          <br /> In case you wish to close your account, please contact our
          Customer Support team. Upon closure, we will remove your personal
          information without undue delay except for information that we are
          obliged to keep pursuant to law. For instance in order to meet
          statutory administrative retention obligations, we need to keep some
          of your account related information (e.g. copies of
          invoices/receipts), for six years.
          <br /> Data may be retained longer in cases where it is used in
          relation to a legal claim or is used in relation to a valid legal
          process.
        </p>
        <br />
        <br />
        <h2 className="fs-22 label-color">Accessing and managing your personal data</h2>
        <p className="label-color fs-18">
          You can directly view and edit your personal details via your personal
          account throughdrivertok.co.uk. There you can also make choices about our
          collection and use of your data. For instance, you can always choose
          in your account settings, whether you wish to receive promotional
          emails, SMS messages, telephone calls or mail from us. How you can
          access or control your personal data will depend on which products and
          services you use.
          <br /> If you cannot access, rectify, or erase certain personal data
          yourselves, if you want a copy of the personal data that we process of
          you, if you wish to request a restriction of processing of your
          personal data or to object to processing, please contact our Customer
          Care department. We will respond to such requests within 30 days.
        </p>
        <br />
        <br />
        <h2 className="fs-22 label-color">Lawful basis for data processing</h2>
        <p className="label-color fs-18">
          We only collect and process your personal data when there is a lawful
          basis to do so. The lawful basis we rely on in this respect includes:
          <br />
          Contract: the processing is necessary to perform your Service
          contract.
        </p>
        <ul>
          <li className="label-color fs-18">
            Legitimate interest: for example, i) a legitimate commercial
            interest to process certain of your personal data, e.g. for running
            our business and the purposes of certain forms of direct marketing
            and profiling; ii) to archive certain account information to
            facilitate you to re‐use your account in the future; or iii) if
            there is a legitimate interest from business or security
            perspective, e.g. to prevent fraud or abuse of our Services, or for
            purpose of network and information security of our IT systems;
          </li>
          <li className="label-color fs-18">
            Legal obligation: the processing necessary to comply with a legal
            obligation, e.g., the legal requirement to keep administrative
            records for a certain period of time, or the legal obligation to
            share certain data on a police order for criminal investigation
            purposes.
          </li>
          <li className="label-color fs-18">
            Public interest task: the processing necessary to assist in tasks in
            the public interest. For instance, to aid enforcement agents in
            verifying the validity of a parking action or parking permit;
          </li>
          <li className="label-color fs-18">
            Consent: where you gave us explicit consent to process the data
            concerned, for example ‐ if applicable ‐ to share your data with
            partners or other third parties for commercial purposes. If you have
            given your consent to the processing, you have the right to withdraw
            your consent at any time. We will discontinue the processing of your
            information upon receipt of your withdrawal. However, any processing
            performed prior to your withdrawal remains a legitimate processing
            based on a valid consent at the time. We will not be under the
            obligation to reverse the processing.
          </li>
        </ul>
        <br />
        <br />
        <h2 className="fs-22 label-color">Questions, concerns and complaints</h2>
        <p className="label-color fs-18">
          If you have questions or concerns about the way in which we use your
          personal data, you can contact our Data Protection Officer (DPO) via
          DPO@drivertok.co.uk <br /> If you feel that an issue has not properly been
          resolved, you also have the right to lodge a complaint with the
          supervisory authority ICO
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
